export function anchors() {
    const body = $("body");
    const $menu = $(".header");
    const $pageNavHolder = $(".page-nav-holder");
    let currentWidth = 0;
    body.on('click', ".has-anchor, .page-nav-holder a", function (e) {
        let $this = $(this);
        if($this.attr("href").includes('#')){
            e.preventDefault();
            const target = $this.attr("href").slice(1);
            if (target) {
                let scrollTop = $(window).scrollTop()
                const anchoredBlock = $(`[id=${target}]`);
                const headerHeight = $menu.length ? $menu.innerHeight() : 0;
                if (anchoredBlock.length) {
                    let anchoredBlockTop = anchoredBlock.offset().top;
                    if (scrollTop > anchoredBlockTop) {
                        if ($pageNavHolder.length) {
                            let $pageNavHolderHeight = $pageNavHolder.innerHeight();
                            $("html, body").animate({scrollTop: anchoredBlockTop - headerHeight - $pageNavHolderHeight}, 500);
                        } else {
                            $("html, body").animate({scrollTop: anchoredBlockTop - headerHeight}, 500);
                        }
                    } else {
                        if ($pageNavHolder.length) {
                            let $pageNavHolderHeight = $pageNavHolder.innerHeight();
                            $("html, body").animate({scrollTop: anchoredBlockTop - $pageNavHolderHeight}, 500);
                        } else {
                            $("html, body").animate({scrollTop: anchoredBlockTop}, 500);
                        }
                    }
                }
                // if ($pageNavHolder.length) {
                //     const tabsNav = $pageNavHolder.find("ul");
                //     let tabIndex = $this.parent().index();
                //     let totalWidth = 0;
                //
                //     tabsNav.find("a").removeClass("active");
                //     $this.addClass("active");
                //     for (let i = 0; i < tabIndex; i++) {
                //         totalWidth += tabsNav.find('li').eq(i).innerWidth();
                //     }
                //     tabsNav.animate({scrollLeft: totalWidth}, 500);
                // }
            }
        }
    });

    function sticky() {
        if ($pageNavHolder.length) {
            const pageNav = $pageNavHolder;
            let pageNavTop = pageNav.offset().top;
            let scrollTop = $(window).scrollTop();
            let headerHeight = $menu.innerHeight();
            let pageNavHeight = pageNav.innerHeight();
            if (scrollTop >= pageNavTop) {
                pageNav.addClass("sticky");
            } else {
                pageNav.removeClass("sticky");
            }
            pageNav.find("ul li").each(function (index, section) {
                if($(section).find("a").attr("href").includes('#')){
                    let target = $(section).find("a").attr("href");
                    if ($(target).length) {
                        $(target).addClass("section-for-sticky-nav");
                    }
                }
            });

            $(".section-for-sticky-nav").each(function (index, section) {
                let $this = $(section);
                let itemOffsetTop = $this.offset().top;
                let indent = 0;
                if ($menu.hasClass("hide")) {
                    indent = pageNavHeight + 5;
                } else {
                    indent = headerHeight + pageNavHeight + 5;
                }
                if (scrollTop + indent >= itemOffsetTop) {
                    let attr = $this.attr("id");
                    if (!$this.hasClass("active")) {
                        $this.addClass('active');
                        if (pageNav.find('a[href="#' + attr + '"]').length) {
                            pageNav.find('a[href="#' + attr + '"]').parent().addClass("active").prev().addClass("prev");
                        }
                    }
                } else {
                    $this.removeClass('active');
                    let attr = $this.attr("id");
                    if (pageNav.find('a[href="#' + attr + '"]').length) {
                        pageNav.find('a[href="#' + attr + '"]').parent().removeClass("active").prev().removeClass("prev");
                    }
                }
            });

            const tabsNav = pageNav.find("ul");
            let tabIndex = tabsNav.find("li.active:not(.prev)").index();
            let totalWidth = 0;

            for (let i = 0; i < tabIndex; i++) {
                totalWidth += tabsNav.find('li.active').eq(i).innerWidth();
            }
            if (currentWidth !== totalWidth) {
                tabsNav.animate({scrollLeft: totalWidth}, 500);
                currentWidth = totalWidth;
            }
        }
    }


    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js